
import { isEmpty } from 'lodash';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';

import GeneralError from '@share/assets/images/general-error.png';
import NoHotelResults from '@share/assets/images/no_hotel_results.png';
import NoCarsResults from '@share/assets/images/no_cars_results.png';

import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { BookingErrorsEnum } from '../../common-types/condos';
import { getAccountUsernameFromPath } from '@share/utils';
import { ILoginState } from '@share/store/slices';
import { useSelector } from 'react-redux';

import './style.scss';

interface IProps {
  message?: string;
  displayExclamationIcon?: boolean;

  isCars?: boolean;
  isHotel?: boolean;
  isCheckout?: boolean;
  hotelId?: string;
}

const SODL_OUT = 'SOLDOUT';

const MESSAGE_EXCLUDE = [SODL_OUT, 'SESSIONEXPIRED', 'UNAUTHORIZED', 'WIDGET_ERROR', 'INVALIDSESSION', 'cars.search.error', 'error'];
const BUTTON_INCLUDE = [SODL_OUT, BookingErrorsEnum.CarUnavailable];

export function CustomErrorPage(props: IProps) {

  const { isCheckout } = props;

  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  
  const history = useHistory();

  const state: any = history.location.state;

  let message = props.message;
  if (isEmpty(message)) {
    if (state?.data) {
      message = state.data;
    }
  }

  const displayMessages = !MESSAGE_EXCLUDE.includes(message || '');
  const displayGoBackSearchButton = BUTTON_INCLUDE.includes(message || '');

  const image = message === SODL_OUT ? GeneralError : props.isCars ? NoCarsResults : NoHotelResults;

  const accountNamePath = getAccountUsernameFromPath(history);

  const accountNameStore = loginStore?.account;

  const accountName = !isEmpty(accountNamePath) ? 
                          accountNamePath :
                          accountNameStore ? 
                            accountNameStore?.name :
                            null;

  const goBack = () => {
    if (isCheckout && props.isHotel) {
      history.push(`/${accountName}${Routes.Hotel}/${props.hotelId}${location.search}`)
    } else {
      history.push(`/${accountName}${props.isCars ? Routes.CarsSearch : Routes.Search}${location.search}`)
    }
  };

  console.log(message);

  return (
    <div className="error-page">
      {props.displayExclamationIcon ? (
        <label style={{ color: 'red' }}><FontAwesomeIcon icon={faTriangleExclamation} size="4x" /></label>) : (
        <img className="error-page__image" src={image} />)}
      
      {isEmpty(message) && !props.isHotel ? (<label className="error-page__title"><FormattedMessage id={'error.custom.error.title'} /></label>) : null}
      
      {!isEmpty(message) ? (<label className="error-page__external-message"><FormattedMessage id={`error.code.${message}`} /></label>) : null}
      
      {displayMessages ? (<label className="error-page__message"><FormattedMessage id={'error.custom.error.retry'} /></label>) : null}
      
      {displayMessages && !props.isHotel ? (<label className="error-page__message-retry"><FormattedMessage id={'error.custom.error.contact_support'} /></label>) : null}
            
      {displayGoBackSearchButton || props.isHotel ? (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', maxWidth: '1020px', paddingRight: '20px', paddingBottom: '20px' }}>
          <BlueButton style={{ padding: '8px 30px' }} onClick={goBack}>
            <FormattedMessage id={isCheckout ? 'back.home' : 'go.back.search'} />
          </BlueButton>
        </div>) : null}
    </div>
  );
}

